export const persistValue = <T>(value: T | undefined, key: string, storage: Storage): void => {
	if (value) {
		const json = JSON.stringify(value);
		storage.setItem(key, json);
	} else {
		storage.removeItem(key);
	}
};

export const getPersistedValue = <T>(key: string, storage: Storage): T | undefined => {
	const json = storage.getItem(key);
	if (!json) return undefined;

	return JSON.parse(json || '');
};

export const updateLocationSearch = (location: Location): Location => {
	const AB_TEST_KEY = 'onboarding_newLink_ab_test';
	let abValue = localStorage.getItem(AB_TEST_KEY);

	if (abValue) {
		window.dataLayer.push({
			event: 'AB_TEST',
			ab_name: 'onboarding_newLink',
			ab_group: abValue,
			ab_test_type: 'onboarding',
		});
	}

	if (location.search === '?config=walking&organicPricesV31=true') {
		if (!abValue) {
			abValue = Math.random() < 0.5 ? 'A' : 'B';
			localStorage.setItem(AB_TEST_KEY, abValue);
			window.dataLayer.push({
				event: 'AB_TEST',
				ab_name: 'onboarding_newLink',
				ab_group: abValue,
				ab_test_type: 'onboarding',
			});
		}

		if (abValue === 'B') {
			return {
				...location,
				search: '?config=walkingV3&organicPricesV31=true&fsv1f10=true&gender=female',
				href:
					location.origin +
					location.pathname +
					'?config=walkingV3&organicPricesV31=true&fsv1f10=true&gender=female',
			};
		}
	}

	return location;
};
